import { loadable } from 'nordic/lazy';

const VehicleSchemaComponentName = 'schema';
const VehicleSchemaComponent = loadable(async () =>
  import(/* webpackChunkName: "chunk-schema-component" */ './VehicleSchema'),
);

const VehicleSchemaRenderConfig = {
  Component: VehicleSchemaComponent,
  isSsrOnly: false,
  isWhenVisible: false,
  isWhenIdle: false,
};

const breadcrumbsComponentName = 'breadcrumbs';
const breadcrumbsComponent = loadable(async () =>
  import(/* webpackChunkName: "chunk-breadcrumb-component" */ './Breadcrumbs'),
);
const breadcrumbsRenderConfig = {
  Component: breadcrumbsComponent,
  isSsrOnly: true,
  isWhenVisible: false,
  isWhenIdle: false,
};

const titleComponentName = 'title';
const titleComponent = loadable(async () =>
  import(/* webpackChunkName: "chunk-title-component" */ './Title'),
);
const titleRenderConfig = {
  Component: titleComponent,
  isSsrOnly: true,
  isWhenVisible: false,
  isWhenIdle: false,
};

const navigationComponentName = 'navigation';
const navigationComponent = loadable(async () =>
  import(/* webpackChunkName: "chunk-navigation-component" */ './Navigation'),
);
const navigationRenderConfig = {
  Component: navigationComponent,
  isSsrOnly: false,
  isWhenVisible: true,
  isWhenIdle: false,
};

const carouselImagesComponentName = 'carousel-images';
const carouselImagesComponent = loadable(async () =>
  import(
    /* webpackChunkName: "chunk-carousel-images-component" */ './CarouselImages'
  ),
);
const carouselImagesRenderConfig = {
  Component: carouselImagesComponent,
  isSsrOnly: true,
  isWhenVisible: false,
  isWhenIdle: false,
};

const offerButtonComponentName = 'offer-button';
const offerButtonComponent = loadable(async () =>
  import(
    /* webpackChunkName: "chunk-offer-button-component" */ './OfferButton'
  ),
);
const offerButtonRenderConfig = {
  Component: offerButtonComponent,
  isSsrOnly: false,
  isWhenVisible: true,
  isWhenIdle: false,
};

const sellButtonComponentName = 'sell-button';
const sellButtonComponent = loadable(async () =>
  import(/* webpackChunkName: "chunk-sell-button-component" */ './SellButton'),
);
const sellButtonRenderConfig = {
  Component: sellButtonComponent,
  isSsrOnly: false,
  isWhenVisible: true,
  isWhenIdle: false,
};

const textInformationComponentName = 'text-information';
const textInformationComponent = loadable(async () =>
  import(
    /* webpackChunkName: "chunk-text-information-component" */ './TextInformation'
  ),
);
const textInformationRenderConfig = {
  Component: textInformationComponent,
  isSsrOnly: false,
  isWhenVisible: true,
  isWhenIdle: false,
};

const technicalSheetComponentName = 'technical-sheet';
const technicalSheetComponent = loadable(async () =>
  import(
    /* webpackChunkName: "chunk-technical-sheet-component" */ './TechnicalSheet'
  ),
);
const technicalSheetRenderConfig = {
  Component: technicalSheetComponent,
  isSsrOnly: false,
  isWhenVisible: true,
  isWhenIdle: false,
};

const TopOffersComponentName = 'top-offers';
const TopOffersComponent = loadable(async () =>
  import(/* webpackChunkName: "chunk-top-offers-component" */ './TopOffers'),
);

const TopOffersRenderConfig = {
  Component: TopOffersComponent,
  isSsrOnly: false,
  isWhenVisible: true,
  isWhenIdle: false,
};

const CarouselBlogComponentName = 'carousel-blogs-by-category';
const CarouselBlog = loadable(async () =>
  import(/* webpackChunkName: "chunk-schema-component" */ './CarouselBlog'),
);

const CarouselBlogRenderConfig = {
  Component: CarouselBlog,
  isSsrOnly: false,
  isWhenVisible: true,
  isWhenIdle: false,
};

const TrendsComparisonComponentName = 'trends';
const TrendsComparison = loadable(async () =>
  import(
    /* webpackChunkName: "chunk-schema-trend-component" */ './TrendsComparison'
  ),
);

const TrendsComparisonRenderConfig = {
  Component: TrendsComparison,
  isSsrOnly: true,
  isWhenVisible: false,
  isWhenIdle: false,
};

const TableComparisonComponentName = 'table-comparison';
const Comparison = loadable(async () =>
  import(
    /* webpackChunkName: "chunk-schema-trend-component" */ './TableComparison'
  ),
);

const TableComparisonRenderConfig = {
  Component: Comparison,
  isSsrOnly: false,
  isWhenVisible: true,
  isWhenIdle: false,
};

const HeaderComparisonComponentName = 'header-comparison';
const HeaderComparison = loadable(async () =>
  import(
    /* webpackChunkName: "chunk-schema-header-component" */ './HeaderComparison'
  ),
);

const HeaderComparisonRenderConfig = {
  Component: HeaderComparison,
  isSsrOnly: false,
  isWhenVisible: true,
  isWhenIdle: false,
};

const componentRenderConfig = {
  [VehicleSchemaComponentName]: VehicleSchemaRenderConfig,
  [breadcrumbsComponentName]: breadcrumbsRenderConfig,
  [titleComponentName]: titleRenderConfig,
  [navigationComponentName]: navigationRenderConfig,
  [carouselImagesComponentName]: carouselImagesRenderConfig,
  [offerButtonComponentName]: offerButtonRenderConfig,
  [sellButtonComponentName]: sellButtonRenderConfig,
  [textInformationComponentName]: textInformationRenderConfig,
  [technicalSheetComponentName]: technicalSheetRenderConfig,
  [TopOffersComponentName]: TopOffersRenderConfig,
  [CarouselBlogComponentName]: CarouselBlogRenderConfig,
  [TrendsComparisonComponentName]: TrendsComparisonRenderConfig,
  [TableComparisonComponentName]: TableComparisonRenderConfig,
  [HeaderComparisonComponentName]: HeaderComparisonRenderConfig,
};

const getComponentConfig = (name) => componentRenderConfig[name] || {};

export default getComponentConfig;
